import { useMemo } from 'react';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const XActionTriggerDetails = ({ trigger, triggerType }: Props) => {
  const accountName = useMemo(() => {
    if (!trigger.signature) return '';
    const match = trigger.signature.match(/^x-follow-(.+)$/);
    return match ? match[1] : '';
  }, [trigger.signature]);

  const profileUrl = useMemo(() => {
    if (!accountName) return '';
    return `https://x.com/${accountName}`;
  }, [accountName]);

  const isFollowTrigger = trigger.signature?.startsWith('x-follow-') ?? false;

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      {isFollowTrigger && accountName && (
        <TriggerExternalLinkDetail label="Account" value={`@${accountName}`} href={profileUrl} />
      )}
    </div>
  );
};
